import { Theme } from '@material-ui/core/styles/createMuiTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import { capitalize } from '@material-ui/core/utils/helpers';
import BookmarkIcon from '@serko/zui-icons/es/BookmarkIcon';
import BookmarkStarIcon from '@serko/zui-icons/es/BookmarkStarIcon';
import classNames from 'classnames';
import React, { FunctionComponent } from 'react';
import compose from 'recompose/compose';
import pure from 'recompose/pure';
import { SegmentTypes } from '../../../../../models/itinerary';

interface OwnProps {
  recommended?: boolean;
  type: SegmentTypes;
}

interface IconProps extends OwnProps, WithStyles<typeof styles> {}

const IconBase: FunctionComponent<IconProps> = ({
  classes,
  recommended,
  type,
}) =>
  recommended ? (
    <BookmarkStarIcon
      className={classNames(
        classes.icon,
        classes.recommended,
        classes[`type${capitalize(type)}` as TypeClassKey],
      )}
    />
  ) : (
    <BookmarkIcon
      className={classNames(
        classes.icon,
        classes[`type${capitalize(type)}` as TypeClassKey],
      )}
    />
  );

// styled
type TypeClassKey = 'typeAir' | 'typeHotel' | 'typeCar';

const styles = ({ zeno: { shortlist } }: Theme) =>
  createStyles({
    icon: {},
    recommended: {
      fill: shortlist && shortlist.air.recommended.main,
    },
    typeAir: {
      '&$icon': {
        fill: shortlist && shortlist.air.shortlisted.main,
      },
      '&$recommended': {
        fill: shortlist && shortlist.air.recommended.main,
      },
    },
    typeHotel: {
      '&$icon': {
        fill: shortlist && shortlist.accommodation.shortlisted.main,
      },
      '&$recommended': {
        fill: shortlist && shortlist.accommodation.recommended.main,
      },
    },
    typeCar: {
      '&$icon': {
        fill: shortlist && shortlist.vehicle.shortlisted.main,
      },
      '&$recommended': {
        fill: shortlist && shortlist.vehicle.recommended.main,
      },
    },
  });

const enhance = compose<IconProps, OwnProps>(
  pure,
  withStyles(styles),
);

export const Icon = enhance(IconBase);

Icon.displayName = 'Icon';
